
export default {
    api_url: process.env.REACT_APP_API_BASE_URL,
    google_client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    microsoft_client_id:  process.env.REACT_APP_MICROSOFT_CLIENT_ID,
};
